import { render, staticRenderFns } from "./OzBox.vue?vue&type=template&id=176124d8&"
import script from "./OzBox.vue?vue&type=script&lang=ts&setup=true&"
export * from "./OzBox.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports